import React, { MutableRefObject } from "react";

import { LayoutType } from "src/organization/pages/project/environment/metrics/logs/types";

import SvgLayout, { SvgLayoutProps } from "./SvgLayout";

type LogsOverviewLayoutProps = {
  ref: MutableRefObject<Element | null>;
} & LayoutType &
  SvgLayoutProps;

const LogsOverviewLayout = (props: LogsOverviewLayoutProps) => {
  const {
    chartId,
    children,
    positions,
    yScale,
    xScale,
    tick,
    onMouseMove,
    onMouseLeave
  } = props;

  return (
    <SvgLayout
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
      xScale={xScale}
      yScale={yScale}
      chartId={chartId}
      positions={positions}
      tick={tick}
    >
      {children}
    </SvgLayout>
  );
};
export default LogsOverviewLayout;
